import { SEO } from "@/components/SEO";
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <SEO title="Página no encontrada" description="La página que buscas no existe." noindex />
      <p className="font-script text-6xl text-cometa-carmesi mb-4">404</p>
      <h1 className="text-4xl md:text-5xl mb-4">Esta página tomó otro camino.</h1>
      <p className="text-lg text-cometa-tinta/60 mb-8">Volvamos a encontrarnos.</p>
      <Link to="/" className="bg-cometa-marino text-cometa-crema px-8 py-4 rounded-full font-semibold hover:bg-cometa-tinta transition">Ir al inicio</Link>
    </div>
  );
}
